import(/* webpackMode: "eager", webpackExports: ["CategoryList"] */ "/vercel/path0/next/src/app/categories/categoryList.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/next/src/app/images/empty-image.jpg");
